import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

function ActionButtons({ row, onEdit, onReset, onReassign, onDelete, t }) {
  const user = row.original;
  return (
    <>
      <MDButton
        variant="text"
        color="info"
        onClick={() => onEdit(user)}
        title={t ? t("admin.annotators.table.actions.edit", "Edit") : "Edit"}
      >
        <Icon>edit</Icon>
      </MDButton>
      <MDButton
        variant="text"
        color="warning"
        onClick={() => onReset(user)}
        title={
          t ? t("admin.annotators.table.actions.resetPassword", "Reset Password") : "Reset Password"
        }
      >
        <Icon>password</Icon>
      </MDButton>
      <MDButton
        variant="text"
        color="success"
        onClick={() => onReassign(user)}
        title={
          t ? t("admin.annotators.table.actions.reassign", "Reassign Samples") : "Reassign Samples"
        }
      >
        <Icon>swap_horiz</Icon>
      </MDButton>
      <MDButton
        variant="text"
        color="error"
        onClick={() => onDelete(user)}
        title={t ? t("admin.annotators.table.actions.delete", "Delete") : "Delete"}
      >
        <Icon>delete</Icon>
      </MDButton>
    </>
  );
}

ActionButtons.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onReassign: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func,
};

ActionButtons.defaultProps = {
  t: null,
};

export default function UsersDataTable({ users, onEdit, onReset, onReassign, onDelete, t }) {
  return {
    columns: [
      {
        Header: t ? t("admin.annotators.table.columns.actions", "Actions") : "Actions",
        accessor: "actions",
        align: "center",
        Cell: (props) => (
          <ActionButtons
            {...props}
            onEdit={onEdit}
            onReset={onReset}
            onReassign={onReassign}
            onDelete={onDelete}
            t={t}
          />
        ),
      },
      {
        Header: t ? t("admin.annotators.table.columns.name", "Name") : "Name",
        accessor: "first_name",
      },
      {
        Header: t
          ? t("admin.annotators.table.columns.phoneNumber", "Phone Number")
          : "Phone Number",
        accessor: "phone_number",
      },
      {
        Header: t ? t("admin.annotators.table.columns.email", "Email") : "Email",
        accessor: "email_id",
      },
      {
        Header: t ? t("admin.annotators.table.columns.country", "Country") : "Country",
        accessor: "country",
      },
      {
        Header: t ? t("admin.annotators.table.columns.state", "State") : "State",
        accessor: "state",
      },
      {
        Header: t ? t("admin.annotators.table.columns.district", "District") : "District",
        accessor: "district",
      },
      {
        Header: t
          ? t("admin.annotators.table.columns.programName", "Program Name")
          : "Program Name",
        accessor: "program_name",
      },
      {
        Header: t ? t("admin.annotators.samples", "Samples") : "Samples",
        accessor: "assigned_samples",
        Cell: ({ value }) => value || "0",
      },
      {
        Header: t ? t("admin.annotators.createdBy", "Created By") : "Created By",
        accessor: "created_by",
      },
    ],
    rows: users.map((user) => ({
      ...user,
      actions: "", // optional if you're not using it directly
    })),
  };
}

UsersDataTable.propTypes = {
  users: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onReassign: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func,
};

UsersDataTable.defaultProps = {
  t: null,
};
